
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"41.914","height":"35.394","viewBox":"0 0 41.914 35.394"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.457 22.991L19.1 17.685l5.3-5.351-1.649-1.637-5.3 5.354-5.353-5.3-1.641 1.639 5.359 5.307-5.3 5.357 1.634 1.643 5.314-5.362 5.356 5.308z","fill":"#fff"}}),_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M17.7 0c9.774 0 14.6 8.078 24.217 17.7-8.376 8.376-14.443 17.7-24.217 17.7a17.7 17.7 0 010-35.4z"}}),_c('path',{attrs:{"d":"M17.697 3A14.6 14.6 0 007.305 7.305 14.6 14.6 0 003 17.697a14.6 14.6 0 004.305 10.392 14.6 14.6 0 0010.392 4.305c2.872 0 5.567-1.01 8.48-3.177 2.866-2.131 5.656-5.157 8.61-8.36.955-1.037 1.93-2.094 2.936-3.154a292.78 292.78 0 01-3.607-3.85c-3.05-3.297-5.684-6.144-8.348-8.07C23.108 3.857 20.618 3 17.698 3m0-3c9.773 0 14.597 8.078 24.216 17.697-8.376 8.376-14.443 17.697-24.217 17.697S0 27.471 0 17.697 7.923 0 17.697 0z","fill":"#eaeaea"}})])])
          )
        }
      }
    